import './BlockUi.scss'
import {ReactNode} from 'react'

interface BlockUiProps {
	blocking: boolean
	message?: ReactNode
	children?: ReactNode
}

const BlockUi = ({blocking, message, children}: BlockUiProps) => {
	return (
		<div className={`block-ui ${blocking ? 'is-blocking' : ''}`}>
			{children}
			{blocking && (
				<div className="block-ui-container">
					<div className="block-ui-overlay"/>
					<div className="block-ui-message-container">
						<div className="block-ui-message">
							{message}
							<div className="loading-indicator">
								<span className="loading-bullet">•</span>
								<span className="loading-bullet">•</span>
								<span className="loading-bullet">•</span>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}

export default BlockUi
